<mat-card class="import-card">
  <mat-card-header>
    <div class="header-row">
      <div>
        <mat-card-title>Import Patient Registrations</mat-card-title>
        <mat-card-subtitle>Upload the patient registration workbook, review rows, then confirm the import.</mat-card-subtitle>
      </div>
      <a mat-stroked-button [href]="templateUrl" download="patient-registration-import-template.xlsx">
        <mat-icon>download</mat-icon>
        Template
      </a>
    </div>
  </mat-card-header>

  <mat-card-content>
    <mat-divider></mat-divider>

    <div class="upload-row">
      <label class="file-picker">
        <input type="file" accept=".xlsx" (change)="onFileSelected($event)">
        <mat-icon>upload_file</mat-icon>
        <span>{{ selectedFile?.name || 'Choose .xlsx file' }}</span>
      </label>

      <mat-checkbox [(ngModel)]="autoApprove">Auto approve after confirmation</mat-checkbox>

      <button mat-flat-button color="primary" (click)="uploadForPreview()" [disabled]="isUploading || !selectedFile">
        @if(isUploading) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon>visibility</mat-icon>
        }
        Preview
      </button>
    </div>

    @if(preview) {
      <section class="summary-row">
        <div><strong>Total</strong><span>{{ preview.totalRows }}</span></div>
        <div><strong>Valid</strong><span>{{ preview.validRows }}</span></div>
        <div><strong>Needs attention</strong><span>{{ preview.invalidRows }}</span></div>
      </section>

      <table mat-table [dataSource]="preview.rows" class="preview-table">
        <ng-container matColumnDef="rowNumber">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row">{{ row.rowNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.firstName }} {{ row.lastName }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row">{{ row.email }}</td>
        </ng-container>

        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef>Phone</th>
          <td mat-cell *matCellDef="let row">{{ row.phoneNumber || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span class="status" [class.ok]="row.isValid" [class.bad]="!row.isValid">
              {{ row.isValid ? 'Ready' : 'Fix row' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="messages">
          <th mat-header-cell *matHeaderCellDef>Messages</th>
          <td mat-cell *matCellDef="let row">{{ messages(row) || '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="previewColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: previewColumns;"></tr>
      </table>

      <div class="actions-row">
        <button mat-stroked-button (click)="reset()">Reset</button>
        <button mat-flat-button color="primary" (click)="confirmImport()" [disabled]="!preview.canConfirm || isConfirming">
          @if(isConfirming) {
            <mat-spinner diameter="18"></mat-spinner>
          } @else {
            <mat-icon>check_circle</mat-icon>
          }
          Confirm Import
        </button>
      </div>
    }

    @if(result) {
      <section class="result-block">
        <h3>Import Result</h3>
        <p>{{ result.succeededRows }} succeeded, {{ result.failedRows }} failed.</p>

        <table mat-table [dataSource]="result.rows" class="preview-table">
          <ng-container matColumnDef="rowNumber">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row">{{ row.rowNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let row">{{ row.email }}</td>
          </ng-container>

          <ng-container matColumnDef="mode">
            <th mat-header-cell *matHeaderCellDef>Mode</th>
            <td mat-cell *matCellDef="let row">{{ row.mode }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status" [class.ok]="row.succeeded" [class.bad]="!row.succeeded">
                {{ row.succeeded ? 'Done' : 'Failed' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="fhirId">
            <th mat-header-cell *matHeaderCellDef>FHIR ID</th>
            <td mat-cell *matCellDef="let row">{{ row.fhirId || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="messages">
            <th mat-header-cell *matHeaderCellDef>Messages</th>
            <td mat-cell *matCellDef="let row">{{ messages(row) || '-' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="resultColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: resultColumns;"></tr>
        </table>
      </section>
    }
  </mat-card-content>
</mat-card>
